import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed, watch } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { usePaymentFieldModel } from '@src/components/pages/membership_form/usePaymentFieldModel';
import RadioField from '@src/components/shared/form_fields/RadioField.vue';
import type { CheckboxFormOption } from '@src/components/shared/form_fields/FormOptions';
import AmountField from '@src/components/shared/form_fields/AmountField.vue';
import { FeeValidity } from '@src/view_models/MembershipFee';
import IbanFields from '@src/components/shared/IbanFields.vue';

interface Props {
	validateFeeUrl: string;
	paymentAmounts: number[];
	paymentIntervals: number[];
	paymentTypes: string[];
	validateBankDataUrl: string;
	validateLegacyBankDataUrl: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Payment',
  props: {
    validateFeeUrl: {},
    paymentAmounts: {},
    paymentIntervals: {},
    paymentTypes: {},
    validateBankDataUrl: {},
    validateLegacyBankDataUrl: {}
  },
  setup(__props: any) {

const props = __props;
const store = useStore();
const { t } = useI18n();

const fee = usePaymentFieldModel( store, 'fee', 'setFee', props.validateFeeUrl );
const interval = usePaymentFieldModel( store, 'interval', 'setInterval', props.validateFeeUrl );
const paymentType = usePaymentFieldModel( store, 'type', 'setType', props.validateFeeUrl );

const paymentTypeIsValid = computed( () => store.getters[ 'membership_fee/typeIsValid' ] );
const feeIsValid = computed( () => store.getters[ 'membership_fee/feeIsValid' ] );
const intervalIsValid = computed( () => store.getters[ 'membership_fee/intervalIsValid' ] );

const minimumAmount = computed(
	() => store.getters[ 'membership_fee/minimumAmount' ]( store.state.membership_address.addressType )
);
const getAmountTitle = computed( () => {
	if ( interval.value === '' ) {
		return t( 'membership_form_payment_amount_title' );
	}
	return t( `membership_form_payment_amount_title_interval_${interval.value}` );
} );

const paymentIntervalsAsOptions = computed<CheckboxFormOption[]>( () => {
	return props.paymentIntervals.map(
		( intervalValue: number, index: number ) => (
			{ value: intervalValue.toString(), label: t( 'donation_form_payment_interval_' + intervalValue ), id: `interval-${ index }` }
		) );
} );

const paymentTypesAsOptions = computed<CheckboxFormOption[]>( () => {
	return props.paymentTypes.map(
		( paymentTypeValue: string, index: number ) => (
			{ value: paymentTypeValue, label: t( paymentTypeValue ), id: `paymentType-${ index }` }
		) );
} );

watch( minimumAmount, async ( newMinimumAmount ) => {
	if ( fee.value < newMinimumAmount ) {
		fee.value = '';
	}
} );

const feeErrorMessage = computed<string>( () => {
	const messages: { [ key: number ]: string } = {
		[ FeeValidity.FEE_VALID ]: '',
		[ FeeValidity.FEE_TOO_LOW ]: t( 'membership_form_payment_amount_error' ),
		[ FeeValidity.FEE_TOO_HIGH ]: t( 'membership_form_payment_amount_too_high' ),
	};
	return messages[ store.getters.feeValidity ].toString();
} );


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(RadioField, {
      name: "interval",
      id: "payment-form-interval",
      label: _ctx.$t('membership_form_payment_interval_title'),
      modelValue: _unref(interval),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(interval) ? (interval).value = $event : null)),
      options: paymentIntervalsAsOptions.value,
      disabled: [],
      "show-error": !intervalIsValid.value,
      "error-message": _ctx.$t('membership_form_interval_error'),
      "is-max-width-field": true
    }, null, 8, ["label", "modelValue", "options", "show-error", "error-message"]),
    _createVNode(AmountField, {
      modelValue: _unref(fee),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(fee) ? (fee).value = $event : null)),
      label: getAmountTitle.value,
      "payment-amounts": __props.paymentAmounts,
      "error-message": feeErrorMessage.value,
      "show-error": !feeIsValid.value,
      "minimum-amount": minimumAmount.value,
      "minimum-amount-message": _ctx.$t('membership_form_payment_amount_description')
    }, {
      message: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('membership_form_payment_amount_cap_notice')), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "label", "payment-amounts", "error-message", "show-error", "minimum-amount", "minimum-amount-message"]),
    (__props.paymentTypes.length > 1)
      ? (_openBlock(), _createBlock(RadioField, {
          key: 0,
          name: "paymentType",
          id: "payment-form-type",
          label: _ctx.$t('donation_form_payment_type_title'),
          modelValue: _unref(paymentType),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(paymentType) ? (paymentType).value = $event : null)),
          options: paymentTypesAsOptions.value,
          disabled: [],
          "show-error": !paymentTypeIsValid.value,
          "error-message": _ctx.$t('membership_form_payment_type_error'),
          "is-max-width-field": true
        }, null, 8, ["label", "modelValue", "options", "show-error", "error-message"]))
      : _createCommentVNode("", true),
    (_unref(paymentType) === 'BEZ')
      ? (_openBlock(), _createBlock(IbanFields, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})